import { UserPasswordRepository } from "@/domain/repository/user-password-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

/** @deprecated Prefer IssueWebFindSnLinkUsecase */
export class SendResetSnEmailUsecase {
  constructor(private readonly userPasswordRepo: UserPasswordRepository) {}

  async execute(email: string): Promise<SATResult<void, SATError>> {
    return this.userPasswordRepo.issueWebFindSnLink({ email });
  }
}
